import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import {
  deleteOneMembership,
  getMembershipList,
} from "../../../redux/membership/action";
import { useNavigate } from "react-router-dom";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import axiosInstance from "../../../redux/api";
import DeleteMembership from "./DeleteMembership";
import { showToast } from "../../Common/Utils/Toaster";
import { getMembershipPlanLabel } from "../../Common/Utils/adminViewUtils";
import "../../Common/Styles/AdminEnhancements.css";

const MemberShipList = () => {
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [section1, setSection1] = useState();
  const [currentComponent, setCurrentComponent] = useState({});
  const [isMounted, setIsMounted] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("semiAnnualList");
  const [params, setParams] = useState({
    search_key: "",
    page: 1,
    duration_type: 2,
  });

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setParams((prevParams) => ({
      ...prevParams,
      duration_type: tab === "semiAnnualList" ? 2 : 1,
    }));
  };

  const membershipList = useSelector(
    (state) => state?.reusableSlice?.membershipList
  );

  const handleGetMembership = () => {
    setIsLoading(true);
    dispatch(getMembershipList(params))
      .then((res) => {
        if (res.data.status) {
          const updatedData = res.data.response.memberships.map((item) => ({
            ...item,
            id: item.id.toString(),
          }));
          setSection1(updatedData);
          setIsMounted(true);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log("error", e);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    handleGetMembership();
  }, [dispatch, params]);

  const summary = useMemo(() => {
    const rows = section1 || [];
    return [
      {
        label: activeTab === "semiAnnualList" ? "Semi-Annual plans" : "Monthly plans",
        value: rows.length,
        subtext: "Visible plans on this tab",
      },
      {
        label: "Active",
        value: rows.filter((item) => Number(item?.status) === 1).length,
        subtext: "Currently sellable",
      },
      {
        label: "Inactive",
        value: rows.filter((item) => Number(item?.status) === 2).length,
        subtext: "Hidden from sales",
      },
    ];
  }, [section1, activeTab]);

  const updateComponent = (id) => {
    navigate(`/updatemembership/${id}`);
  };

  const handleDragEnd1 = (result) => {
    if (!result.destination) return;

    const items = Array.from(section1);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setSection1(items.map((item, index) => ({ ...item, position: index + 1 })));
    hitapiupdatechanges1(items.map((item) => Number(item.id)));
  };

  const hitapiupdatechanges1 = (value) => {
    axiosInstance
      .post("/membership/membership_setup", { ids: value })
      .then((res) => {
        if (res.data.status) {
          handleGetMembership();
          showToast(res?.data?.response?.message, "success");
        } else {
          showToast(res?.data?.response?.message, "error");
        }
      })
      .catch((e) => console.log(e.message, "update membership position"));
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneMembership(currentComponent?.id))
        .then((res) => {
          if (res.data.status) {
            handleGetMembership();
          }
        })
        .catch((e) => console.log(e.message, "error in delete membership"));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <Card>
      <div className="p-3">
        <div className="category-wrapper d-flex justify-content-center flex-column w-100">
          <div className="d-flex justify-content-between align-items-center sub-head">
            <div>
              <h4>Membership List</h4>
              <div className="admin-toolbar-note">
                Plan setup is shown using admin wording: Monthly and Semi-Annual.
              </div>
            </div>
          </div>
          <div className="admin-summary-grid mt-3">
            {summary.map((item) => (
              <div className="admin-summary-card" key={item.label}>
                <div className="admin-summary-label">{item.label}</div>
                <div className="admin-summary-value">{item.value}</div>
                <div className="admin-summary-subtext">{item.subtext}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="pt-1 pb-3 d-flex align-items-center" style={{ columnGap: "10px" }}>
        <button
          onClick={() => handleTabClick("semiAnnualList")}
          className={`tab-button ${activeTab === "semiAnnualList" ? "active" : ""}`}
        >
          Semi-Annual
        </button>
        <button
          onClick={() => handleTabClick("monthlyList")}
          className={`tab-button ${activeTab === "monthlyList" ? "active" : ""}`}
        >
          Monthly
        </button>
      </div>
      {isLoading ? (
        <FullScreenLoader />
      ) : (
        <CardBody className="table-sec px-3">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Duration</th>
                <th scope="col">Membership Type</th>
                <th scope="col">Website Price (SAR)</th>
                <th scope="col">Shopify Price (USD)</th>
                <th scope="col">Status</th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>

            <DragDropContext onDragEnd={handleDragEnd1}>
              {isMounted ? (
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <tbody {...provided.droppableProps} ref={provided.innerRef}>
                      {membershipList?.memberships?.length > 0 ? (
                        <>
                          {section1?.map((item, index) => (
                            <Draggable key={item.id} draggableId={item.id} index={index}>
                              {(provided) => (
                                <tr
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <td>{index + 1 + (params?.page - 1) * 10}</td>
                                  <td>{item?.title}</td>
                                  <td>{item?.duration}</td>
                                  <td>{getMembershipPlanLabel(item)}</td>
                                  <td>{item?.price}</td>
                                  <td>{item?.dollar_price ?? 0}</td>
                                  <td>
                                    <span
                                      className={`admin-chip admin-chip--${
                                        Number(item?.status) === 1 ? "success" : "warning"
                                      }`}
                                    >
                                      {item?.status == 1 ? "Active" : item?.status == 2 ? "Inactive" : "--"}
                                    </span>
                                  </td>
                                  <td>
                                    <div
                                      className="d-flex align-items-center justify-content-center"
                                      style={{ columnGap: "10px" }}
                                    >
                                      <button
                                        className="border-button"
                                        onClick={() => updateComponent(item?.id)}
                                      >
                                        <span>Update</span>
                                      </button>
                                      <button
                                        className="background-button"
                                        onClick={() => {
                                          setModal(true);
                                          setCurrentComponent(item);
                                        }}
                                      >
                                        <span>Delete</span>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No membership Found
                          </td>
                        </tr>
                      )}
                      {provided.placeholder}
                    </tbody>
                  )}
                </Droppable>
              ) : (
                ""
              )}
            </DragDropContext>
          </table>
        </CardBody>
      )}
      <CommonPagination
        params={params}
        setParams={setParams}
        pagination_meta={membershipList?.pagination_meta}
      />
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <DeleteMembership
          modalTitle="Membership"
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </Card>
  );
};

export default MemberShipList;
